module.exports = __webpack_public_path__ + "img/01.6e5e245b.jpg";